import React, { useState, useRef, useEffect } from 'react';
import {
    Stepper, Step, StepLabel, Box, Typography, useTheme
} from '@mui/material';
import { StepsContainer, TwoButton, SaveButton, InnerTwoButtons, FooterPart, HeaderPart, StepText } from './steps/Styles';
import ButtonComponent from 'src/components/shared/Button';
import { ReactComponent as Add } from '../../../../assets/images/add-square.svg';
import { ReactComponent as Previous } from '../../../../assets/images/arrow-left 2.svg';
import { useDispatch } from 'react-redux';
import PersonalInfoStep from './steps/PersonalInfoStep';
import ProfessionalInfoStep from './steps/ProfessionalInfoStep';
import LoginInfoStep from './steps/LoginInfoStep';
import EducationalInfoStep from './steps/EducationalInfoStep';
import ConsultingInfoStep from './steps/ConsultingInfoStep';
import LinkStep from './steps/LinkStep';
import FutureOptionsSteps from './steps/FutureOptionsSteps';
import SeoPurposeStep from './steps/SeoPurposeStep';
import DoctorTimingStep from './steps/DoctorTimingStep';
import LoginForm from './steps/LoginForm';
import useResponsive from 'src/components/hooks/useResponsive';
import { getDoctorProfileByIdRequest, postDoctorProfileRequest } from '../../store/publicActions';
import { jwtDecode } from 'jwt-decode';
import { getUserFromToken } from 'src/DecodeToken';
import ThankYou from './steps/ThankYou';
import { useNavigate } from 'react-router-dom';

const OnBoardForm = () => {

    const dispatch = useDispatch();
    const { isMobile, isTablet } = useResponsive();
    const navigate = useNavigate();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';
    const [activeStep, setActiveStep] = useState(0);
    const activeSteps = activeStep > 0;
    const [formData, setFormData] = useState({});
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [doctorProfile, setDoctorProfile] = useState(null);
    const [doctorProfileData, setDoctorProfileData] = useState([]);
    const [submitDone, setSubmitDone] = useState(false);

    const personalInfoRef = useRef();
    const loginInfoRef = useRef();
    const professionalInfoRef = useRef();
    const educationalInfoRef = useRef();
    const consultingInfoRef = useRef();
    const linkInfoRef = useRef();
    const futureInfoRef = useRef();
    const seoPurposeInfoRef = useRef();
    const doctTimingInfoRef = useRef();
    // const doctId = getUserFromToken();
    // const doctId = "685cde3bec2831c44a513775";


    const doctId = getUserFromToken();
    useEffect(() => {

        if (!doctId || doctId === 'null' || doctId === 'undefined') {
            navigate('/public/login');
        }
    }, [doctId, navigate]);


    const stepperData = [
        {
            label: "Personal Info", component: <PersonalInfoStep data={doctorProfileData?.personalInfo || doctorProfile?.personalInfo} innerRef={personalInfoRef} setDoctorProfileData={setDoctorProfileData} />
        },
        { label: "Login Info", component: <LoginInfoStep data={doctorProfileData?.loginInfo || doctorProfile?.loginInfo} innerRef={loginInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: "Professional Info", component: <ProfessionalInfoStep data={doctorProfileData?.professionalInfo || doctorProfile?.professionalInfo} innerRef={professionalInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: "Educational Info", component: <EducationalInfoStep data={doctorProfileData?.educationalInfo || doctorProfile?.educationalInfo} innerRef={educationalInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: "Consulting", component: <ConsultingInfoStep data={doctorProfileData?.consulting || doctorProfile?.consulting} innerRef={consultingInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: "Links", component: <LinkStep data={doctorProfileData?.links || doctorProfile?.links} innerRef={linkInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        // { label: "Photos", component: <Photo data={doctorProfile?.photos} /> },
        { label: "Future Options", component: <FutureOptionsSteps data={doctorProfileData?.futureOptions || doctorProfile?.futureOptions} innerRef={futureInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: 'Seo Purpose', component: <SeoPurposeStep data={doctorProfileData?.seoPurpose || doctorProfile?.seoPurpose} innerRef={seoPurposeInfoRef} setDoctorProfileData={setDoctorProfileData} /> },
        { label: "Doctor Timings", component: <DoctorTimingStep data={doctorProfileData?.doctorTimings || doctorProfile?.doctorTimings} innerRef={doctTimingInfoRef} setDoctorProfileData={setDoctorProfileData} onStepSubmitSuccess={() => setSubmitDone(true)} /> },
        // { label: "Accepting Appointments", component: <AcceptiongAppointment data={doctorProfile?.acceptingAppointments} /> },

    ];

    const formikRefs = [personalInfoRef, loginInfoRef, professionalInfoRef, educationalInfoRef, consultingInfoRef, linkInfoRef, futureInfoRef, seoPurposeInfoRef, doctTimingInfoRef];

    const stepperRef = useRef(null);

    const handleNext = async () => {
        const currentRef = formikRefs[activeStep];

        if (currentRef?.current?.submitForm) {
            await currentRef.current.submitForm(); // This triggers Formik's validation and submit
        }


        if (currentRef?.current?.isValid === false) return;

        const isLastStep = activeStep === stepperData.length - 1;

        if (isLastStep) {
            const updatedProfileData = {
                ...doctorProfileData,
                id: doctId,
            };

            // Clean invalid fields from sub-objects to prevent backend 500 errors
            const cleanEmptyStrings = (obj) => {
                Object.keys(obj).forEach(k => {
                    if (obj[k] === "") delete obj[k];
                });
                return obj;
            };

            ['personalInfo', 'loginInfo', 'professionalInfo', 'educationalInfo', 'consulting', 'links', 'futureOptions', 'seoPurpose'].forEach(key => {
                if (updatedProfileData[key]) {
                    if (Array.isArray(updatedProfileData[key])) {
                        updatedProfileData[key] = updatedProfileData[key].map(item => {
                            const { id, createdAt, updatedAt, ...rest } = item || {};
                            return cleanEmptyStrings(rest);
                        });
                    } else {
                        const { id, createdAt, updatedAt, ...rest } = updatedProfileData[key];
                        updatedProfileData[key] = cleanEmptyStrings(rest);
                    }
                }
            });

            if (updatedProfileData.doctorTimings && updatedProfileData.doctorTimings.timings) {
                updatedProfileData.doctorTimings.timings = updatedProfileData.doctorTimings.timings.map(t => {
                    const { id, createdAt, updatedAt, ...rest } = t || {};
                    return rest;
                });
            }

            console.log("Submitting all data", updatedProfileData);

            const response = await new Promise((resolve, reject) => {
                dispatch(postDoctorProfileRequest(updatedProfileData, resolve, reject));
            });

            if (response) {
                dispatch(getDoctorProfileByIdRequest(doctId, (res) => {
                    setDoctorProfile(res);
                }));

            }
        } else {
            setActiveStep((prev) => prev + 1);
        }
    };
    useEffect(() => {
        const submitFinalStep = async () => {
            const updatedProfileData = {
                ...doctorProfileData,
                id: doctId,
            };

            // Clean invalid fields from sub-objects to prevent backend 500 errors
            const cleanEmptyStrings = (obj) => {
                Object.keys(obj).forEach(k => {
                    if (obj[k] === "") delete obj[k];
                });
                return obj;
            };

            ['personalInfo', 'loginInfo', 'professionalInfo', 'educationalInfo', 'consulting', 'links', 'futureOptions', 'seoPurpose'].forEach(key => {
                if (updatedProfileData[key]) {
                    if (Array.isArray(updatedProfileData[key])) {
                        updatedProfileData[key] = updatedProfileData[key].map(item => {
                            const { id, createdAt, updatedAt, ...rest } = item || {};
                            return cleanEmptyStrings(rest);
                        });
                    } else {
                        const { id, createdAt, updatedAt, ...rest } = updatedProfileData[key];
                        updatedProfileData[key] = cleanEmptyStrings(rest);
                    }
                }
            });

            if (updatedProfileData.doctorTimings && updatedProfileData.doctorTimings.timings) {
                updatedProfileData.doctorTimings.timings = updatedProfileData.doctorTimings.timings.map(t => {
                    const { id, createdAt, updatedAt, ...rest } = t || {};
                    return rest;
                });
            }

            console.log("Auto-submitting doctor profile (from DoctorTimingStep)", updatedProfileData);

            const response = await new Promise((resolve, reject) => {
                dispatch(postDoctorProfileRequest(updatedProfileData, resolve, reject));
            });

            if (response) {
                dispatch(getDoctorProfileByIdRequest(doctId, (res) => {
                    setDoctorProfile(res);
                }));
                // Intentionally not redirecting or unsetting submitDone,
                // so the ThankYou screen remains visible.
            }
        };

        if (submitDone && activeStep === stepperData.length - 1) {
            submitFinalStep();
        }
    }, [submitDone, activeStep, doctorProfileData, doctId, dispatch, navigate]);

    const handleBack = () => setActiveStep((prev) => prev - 1);
    const handleSkip = () => setActiveStep((prev) => prev + 1);

    const handleOtpSuccess = (number) => {
        setFormData({ phone: number });
        setIsOtpVerified(true);
    };

    useEffect(() => {
        if (stepperRef.current) {
            const stepper = stepperRef.current;
            const steps = stepper.querySelectorAll('.MuiStep-root');
            const activeStepElement = steps[activeStep];
            if (activeStepElement) {
                activeStepElement.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest',
                });
            }
        }
    }, [activeStep]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await new Promise((resolve, reject) => {
                    dispatch(getDoctorProfileByIdRequest(doctId, resolve, reject));
                });
                if (response) {
                    setDoctorProfile(response);
                    console.log("my doctor profile fetch success", response);
                    // toast.success("Doctor profile data loaded!"); 
                } else {
                    console.log('Error fetching doctor profile: Response is empty');
                }
            } catch (error) {
                console.error('Error fetching doctor profile', error);
            }
        }
        fetchData();
    }, [doctId, dispatch]);



    return (
        <Box >
            {
                submitDone && activeStep === stepperData.length - 1 ? (
                    <ThankYou />
                )
                    :

                    (
                        <>
                            <StepsContainer>


                                <HeaderPart>



                                    <Typography variant="subtitle2" textAlign="center" mb={2}>
                                        Step {activeStep + 1} of {stepperData.length} — {stepperData[activeStep]?.label}

                                    </Typography>

                                    <Box
                                        ref={stepperRef}
                                        sx={{
                                            overflowX: 'auto',
                                            whiteSpace: 'nowrap',
                                            scrollbarWidth: 'none',
                                            '&::-webkit-scrollbar': { display: 'none' },

                                        }}
                                    >
                                        <Stepper activeStep={activeStep} alternativeLabel sx={{
                                            width: 'max-content',
                                            minWidth: 800,
                                            paddingBottom: 1,
                                        }}>
                                            {stepperData.map(({ label }) => (
                                                <Step key={label}>
                                                    <StepLabel
                                                    >{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Box>
                                </HeaderPart>
                                <Box padding="20px">
                                    <Box>
                                        {stepperData[activeStep]?.component}

                                    </Box>

                                </Box>
                                <FooterPart sx={{ justifyContent: activeSteps ? 'space-between' : 'flex-end' }}>

                                    {activeStep > 0 && (
                                        <ButtonComponent
                                            variant="none"
                                            startIcon={<Previous width={Width} height={Height} />}
                                            onClick={handleBack}>Back</ButtonComponent>
                                    )}

                                    <InnerTwoButtons>
                                        {/* {activeStep < 8 && (<ButtonComponent variant="none" onClick={handleSkip}>Skip</ButtonComponent>)} */}


                                        <SaveButton
                                            onClick={handleNext}
                                            startIcon={<Add width={Width} height={Height} />}
                                            type="submit">  {activeStep === stepperData.length - 1 ? 'Submit' : 'Next'}</SaveButton>
                                    </InnerTwoButtons>

                                </FooterPart>
                            </StepsContainer>
                        </>
                    )}
        </Box>
    );
};

export default OnBoardForm;
